export default "{\n    \"title\": \"Planned Maintenance Details\",\n    \"breadcrumbsParentLinkText\": \"Planned Maintenance\"\n}\n"